const NODES = [
  ["BJ-CERV", "Cervical", 100, 52, 9], ["BJ-SHO", "Shoulder", 70, 72, 10], ["BJ-SHO", "Shoulder", 130, 72, 10],
  ["BJ-THOR", "Thoracic", 100, 92, 10], ["BJ-ELB", "Elbow", 58, 118, 8], ["BJ-ELB", "Elbow", 142, 118, 8],
  ["BJ-LUMB", "Lumbar", 100, 128, 10], ["BJ-WRH", "Wrist/hand", 50, 160, 8], ["BJ-WRH", "Wrist/hand", 150, 160, 8],
  ["BJ-PELV", "Pelvis/SI", 100, 152, 9], ["BJ-HIP", "Hip", 82, 166, 9], ["BJ-HIP", "Hip", 118, 166, 9],
  ["BJ-KNEE", "Knee", 85, 228, 10], ["BJ-KNEE", "Knee", 115, 228, 10], ["BJ-ANK", "Ankle/foot", 86, 290, 9], ["BJ-ANK", "Ankle/foot", 114, 290, 9],
];
const EXTRA = [["BR-NEURO", "Neuro"], ["BJ-BAL", "Balance"], ["BR-CP", "Cardio-pulmonary"], ["BR-PF", "Pelvic floor"]];

export default function BodyMap({ value, onChange }) {
  return (
    <div data-testid="body-map" className="flex flex-col items-center gap-3">
      <svg viewBox="0 0 200 310" className="w-full max-w-[210px]">
        <g fill="#F1F5F9" stroke="#CBD5E1" strokeWidth="1.5">
          <circle cx="100" cy="26" r="17" />
          <path d="M78 46 h44 l22 24 l12 50 l-8 44 h-8 l-6 -42 l-8 -22 v40 l6 18 l-2 54 l2 60 h-14 l-6 -60 l-4 -50 h-4 l-4 50 l-6 60 h-14 l2 -60 l-2 -54 l6 -18 v-40 l-8 22 l-6 42 h-8 l-8 -44 l12 -50 z" />
        </g>
        {NODES.map(([code, label, x, y, r], i) => (
          <circle key={i} cx={x} cy={y} r={r} role="button" aria-label={label} data-testid={`body-map-node-${code.toLowerCase()}-${i}`} onClick={() => onChange(value === code ? "" : code)}
            className="body-node" fill={value === code ? "#22D3EE" : "#FFFFFF"} stroke={value === code ? "#0D9488" : "#94A3B8"} strokeWidth="2">
            <title>{label}</title>
          </circle>
        ))}
      </svg>
      <div className="flex flex-wrap justify-center gap-1.5">
        {EXTRA.map(([code, label]) => (
          <button key={code} data-testid={`body-map-chip-${code.toLowerCase()}`} onClick={() => onChange(value === code ? "" : code)}
            className={`rounded-full border px-2.5 py-0.5 text-[11px] font-medium transition-colors ${value === code ? "border-teal-500 bg-cyan-50 text-teal-800" : "border-slate-200 text-slate-600 hover:border-slate-300"}`}>
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}
